import { useQuery } from '@tanstack/react-query';

import type { GlobalAccount, GUID, OnboardingDebugView } from '@ndvr/customer-api';

import { CustomerApi } from 'API';

/** Everything about one household's onboarding, with the document extractions decrypted; for support users only. */
export const useOnboardingDebugViewQuery = (householdGUID?: string) =>
    useQuery<OnboardingDebugView>({
        queryKey: ['onboarding', householdGUID, 'debug'],
        queryFn: async () => {
            const [response] = await CustomerApi().getOnboardingDebugView(householdGUID as GUID<GlobalAccount>);
            if (!response) {
                throw new Error('Unable to load the onboarding');
            }
            return response;
        },
        enabled: !!householdGUID,
        retry: false,
    });
